@if (form.formFields && form.config && form.data) {
  <dhs-form [action]="'MODIFY'" [config]="form.config"
    [fieldGroup]="form.formFields" [data]="form.data" (saveFinished)="onSubmit($event)">
  </dhs-form>
}